import {Component, ElementRef, OnInit, ViewChild, OnDestroy, AfterViewInit} from '@angular/core';
import { DolarizacionService } from '../../../services/dolarizacion-service';
import { FilterType, FilterSettings, DateRangeFilter, NumberRangeFilter } from '../../common/dialog/generic-filter-dialog/generic-filter-dialog.component';
import {
  DialogsService,
  ProductoService,
  CosechaService,
  NegociosService,
  SpinnerService,
  PermisosService,
  PERM_ACCIONES_ID
} from '../../../services';
import * as moment from 'moment';
import { TnsPipe, PricePipe } from '../../../utils/pipes';
import { Subscription } from 'rxjs/Subscription';
import {MdSnackBar} from '@angular/material';
import {NotificationSnackbarComponent} from '../../common/snackbar/notification-snackbar/notification-snackbar.component';
import { isArray } from "rxjs/util/isArray";
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-dolarizacion',
  templateUrl: './dolarizacion.component.html',
  styleUrls: ['./dolarizacion.component.scss']
})
export class DolarizacionComponent implements OnInit, OnDestroy, AfterViewInit {

  dolarizacion = [];

  showFilters = false;

  // hack, en el init se carga la vista mediante el toggle, de entrada, el history es true
  viewHistory = true;
  // hack, usamos el first load para no guardar filtros laa primera vez que entramos al componente
  firstLoad = true;

  filter: any = {
    AscendingOrder: true,
    ColumnOrder: '',
    Page: 0
  };

  // usamos esta flag para saber que ya alcanzamos el final de una consulta para no llamar la siguiente pagina
  finalReached = false;

  listFilterBackup = null;
  historyFilterBackup = null;

  anchoTabla = '4000px';

  filtersNames = [
    {column: 'Acción',                filter: '',                              filterType: FilterType.number,      dataName: 'Aceptada'},
    {column: 'Fecha',                 filter: 'FilterFechaModificacion',       filterType: FilterType.dateRange,   dataName: 'FechaModificacion'},
    {column: 'Acopio',                filter: 'FilterAcopio',                  filterType: FilterType.acopio,      dataName: 'Acopio'},
    {column: 'Cod. Comp.',            filter: 'FilterCodigoComprobante',       filterType: FilterType.number,      dataName: 'CodigoComprobante'},
    {column: 'Apodo Comp.',           filter: 'FilterApodoComprobante',        filterType: FilterType.string,      dataName: 'ApodoComprobante'},
    {column: 'Nº Liq',                filter: 'FilterNumeroLiquidacion',       filterType: FilterType.number,      dataName: 'NumeroLiquidacion'},
    {column: 'AB Cliente',            filter: 'FilterIdCliente',               filterType: FilterType.cliente,     dataName: 'ClienteCodigo'},
    {column: 'Nombre Cliente',        filter: 'FilterNombreCliente',           filterType: FilterType.cliente,     dataName: 'ClienteNombre'},
    {column: 'Producto',              filter: 'FilterProducto',                filterType: FilterType.producto,    dataName: 'Producto'},
    {column: 'Cosecha',               filter: 'FilterCosecha',                 filterType: FilterType.cosecha,     dataName: 'Cosecha'},
    {column: 'Fecha Liquidacion',     filter: 'FilterFechaLiquidacion',        filterType: FilterType.dateRange,   dataName: 'FechaLiquidacion'},
    {column: 'Tns. Liq',              filter: 'FilterToneladasLiquidacion',    filterType: FilterType.numberRange, dataName: 'ToneladasLiquidacion'},
    {column: 'Tns Negocio',           filter: 'FilterToneladasContrato',       filterType: FilterType.numberRange, dataName: 'ToneladasContrato'},
    {column: 'Saldo Neto IVA',        filter: 'FilterSaldoNeto',               filterType: FilterType.numberRange, dataName: 'SaldoNeto'},
    {column: 'Negocio',               filter: 'FilterTipoContrato',            filterType: FilterType.tipoPosicion,dataName: 'TipoContrato'},
    {column: 'Nº Contrato',           filter: 'FilterNumeroContrato',          filterType: FilterType.number,      dataName: 'NumeroContrato'},
    {column: 'Forma de Dolarización', filter: 'FilterFormaDolarizacion',       filterType: FilterType.string,      dataName: 'FormaDolarizacion'},
    {column: 'Fecha Negocio',         filter: 'FilterFechaContrato',           filterType: FilterType.dateRange,   dataName: 'FechaContrato'},
    {column: 'Fec. TC Propuesta',     filter: 'FilterFechaCotizacion',         filterType: FilterType.dateRange,   dataName: 'FechaCotizacion'},
    {column: 'TC Propuesto',          filter: 'FilterValorCotizacion',         filterType: FilterType.numberRange, dataName: 'ValorCotizacion'},
    {column: 'Fec.Tope Pesif.',       filter: 'FilterFechaLimitePesificacion', filterType: FilterType.dateRange,   dataName: 'FechaLimitePesificacion'},
  ];

  columnas = [];
  anchoDeCelda = [];

  columnasLista = ['Aceptar', 'Rechazar', 'Acopio', 'Cod. Comp.', 'Apodo Comp.', 'Nº Liq', 'AB Cliente', 'Nombre Cliente', 'Producto',
    'Cosecha', 'Fecha Liquidacion', 'Tns. Liq', 'Saldo Neto IVA', 'Negocio', 'Nº Contrato', 'Tns Negocio',
    'Fecha Negocio', 'Forma de Dolarización', 'Fec. TC Propuesta', 'TC Propuesto', 'Fec.Tope Pesif.', 'Motivo de Rechazo'];

  anchoDeCeldaLista = ['75px', '75px', '110px', '110px', '120px', '110px', '110px', '130px', '110px',
    '110px', '140px', '110px', '140px', '110px', '110px', '110px',
    '120px', '400px', '140px', '110px', '130px', '500px'];

  columnasHistorial = ['Acción', 'Fecha', 'Acopio', 'Cod. Comp.', 'Apodo Comp.', 'Nº Liq', 'AB Cliente', 'Nombre Cliente', 'Producto',
  'Cosecha', 'Fecha Liquidacion', 'Tns. Liq', 'Saldo Neto IVA', 'Negocio', 'Nº Contrato', 'Tns Negocio',
  'Fecha Negocio', 'Forma de Dolarización', 'Fec. TC Propuesta', 'TC Propuesto', 'Fec.Tope Pesif.', 'Motivo de Rechazo'];

  anchoDeCeldaHistorial = ['150px', '120px', '110px', '110px', '120px', '110px', '110px', '130px', '110px',
  '110px', '140px', '110px', '140px', '110px', '110px', '110px',
  '120px', '400px', '140px', '110px', '130px', '500px'];

  // cambiamos la logica de la pipe keys: en lugar de añadir las keys que quitar de la consulta, creamos un array con solo las keys validas
  // Y EN EL ORDEN CORRECTO, PUES ESTE ARRAY SE USA PARA ORDENAR EN LA PIPE
  allowedKeys = ['Acopio', 'CodigoComprobante', 'ApodoComprobante', 'NumeroLiquidacion', 'ClienteCodigo', 'ClienteNombre', 'Producto',
    'Cosecha', 'FechaLiquidacion', 'ToneladasLiquidacion', 'SaldoNeto', 'TipoContrato', 'NumeroContrato', 'ToneladasContrato',
    'FechaContrato', 'FormaDolarizacion', 'FechaCotizacion', 'ValorCotizacion', 'FechaLimitePesificacion'];

  @ViewChild('motivoInput') motivoInput: ElementRef;
  @ViewChild('mainDiv') mainDiv: ElementRef;

  @ViewChild('topScroller') topScroller: ElementRef;
  @ViewChild('header') tableHeader: ElementRef;
  @ViewChild('table') table: ElementRef;
  @ViewChild('quickFilters') quickFilters: ElementRef;

  mouseScrollAllowed = false;
  mouseScrollInterval;

  sortTimeout;

  filterChips: any[] = [];

  productoOptions = [];
  cosechaOptions = [];
  negocioTipoOptions = [];

  public dolarizacionLoading = false;
  spinnerSubscription: Subscription;

  private verticalScroll;

  /** Variables Scroll Vertical **/
  private tableHeaderBase = 79;
  private scrollStartPoint = 176;

  paginationSubscription: Subscription;

  public userCanValidate = false;

  constructor(private dolarizacionService: DolarizacionService,
              private dialogsService: DialogsService,
              private tnsPipe: TnsPipe,
              private pricePipe: PricePipe,
              private productosService: ProductoService,
              private cosechaService: CosechaService,
              private negociosService: NegociosService,
              private spinnerService: SpinnerService,
              private snackBar: MdSnackBar,
              private permisosService: PermisosService) {
    this.mouseScrollInterval = setInterval(() => { this.mouseScrollAllowed = true; }, 15);
    this.productosService.loadOptions();
    this.cosechaService.loadOptions();
    this.productosService.Options.subscribe(x => this.productoOptions = x);
    this.cosechaService.Options.subscribe(x => this.cosechaOptions = x);
    // nos suscribimos al spinner para saber si esta cargando la vista
    this.spinnerSubscription = this.spinnerService.showSoftFlag$.subscribe(x => this.dolarizacionLoading = x);
    this.userCanValidate = this.permisosService.permisoAutorizado(PERM_ACCIONES_ID.A_Autorizacion_Dolarizacion);
    if (!this.userCanValidate) {
      // quitamos las columnas Aceptar, rechazar y motivo de rechazo en caso de no poseer permiso de validacion
        this.columnasLista.pop();
        this.columnasLista.shift();
        this.columnasLista.shift();
        this.anchoDeCeldaLista.pop();
        this.anchoDeCeldaLista.shift();
        this.anchoDeCeldaLista.shift();
    }
  }

  ngOnInit() {
    this.toggleView('');
    this.negocioTipoOptions = this.negociosService.getTipoSelectOptions();
  }

  ngOnDestroy() {
    clearInterval(this.mouseScrollInterval);
    this.spinnerSubscription.unsubscribe();
  }

  ngAfterViewInit() {
    // CUSTOM VERTICAL SCROLL CON STICKY HEADER
    // quien posee el scroll vertical de la pantalla es el mat-drawer-content
    this.verticalScroll = window.document.querySelector('.mat-drawer-content');
    this.verticalScroll.addEventListener('scroll', e => {
      this.recalcularPosicionHeader();
    });
    // lo ejecutamos una vez para colocarlo correctamente ni bien ingresamos a la vista
    this.recalcularPosicionHeader();

    // INFINITE SCROLL
    this.paginationSubscription = Observable.fromEvent(this.verticalScroll, 'scroll')
      .debounceTime(300)
      .map(() => this.verticalScroll.scrollTop)
      .subscribe(x => {
        const max = this.verticalScroll.scrollHeight - this.verticalScroll.clientHeight;
        if (x > max * 0.85) {
          this.loadData(false);
        }
      });

  }

  recalcularPosicionHeader() {
    const extra = this.quickFilters.nativeElement.offsetHeight;
    /** Si el scroll verical de la pantalla es mayor al punto donde iniciamos el scroll MAS el espacio de los filtros **/
    if (this.verticalScroll.scrollTop > this.scrollStartPoint + extra) {
      this.topScroller.nativeElement.style.top = (this.verticalScroll.scrollTop - 175 - extra) + 'px';
      this.tableHeader.nativeElement.style.top = (this.verticalScroll.scrollTop + 17 - extra - 192) + 'px';


    } else {
      this.tableHeader.nativeElement.style.top = '0px';
      this.topScroller.nativeElement.style.top = '0px';
    }
  }

  loadData(resetPagination = true) {
    if (resetPagination) {
      this.dolarizacion = [];
      this.finalReached = false;
    }
    // si alcanzamos el final de paginas, no buscamos a no ser que se reinicie la consulta
    if (this.finalReached) { return; }
    // copiamos el filtro dado que debemos editarlo levemente
    const copy = {PageSize: 20, PageNumber: resetPagination ? 0 : this.filter.Page};
    Object.keys(this.filter).forEach(x => {
      if (x === 'FilterIdCliente' || x === 'FilterNombreCliente') {
        copy['FilterCliente'] = this.filter[x].map(y => y.ID);
      } else if (x === 'FilterAcopio') {
        copy[x] = this.filter[x].map(y => y.ID);
      } else if (x === 'FilterCodigoComprobante' || x === 'FilterNumeroLiquidacion' || x === 'FilterNumeroContrato') {
        copy[x] = {MinValue: this.filter[x], MaxValue: this.filter[x]};
      } else {
        copy[x] = this.filter[x];
      }
    });
    if (this.filter.ColumnOrder !== '') {
      copy['ColumnOrder'] = this.filtersNames[this.filtersNames.findIndex(x => x.column === this.filter.ColumnOrder)].dataName;
    } else {
      delete copy['ColumnOrder'];
    }
    this.spinnerService.setSoftSpinnerShowFlag(true);
    if (this.viewHistory) {
      // historial
      this.dolarizacionService.getDolarizacionHistory(copy).subscribe(x => {
        this.setupDolarizacion(x);
      }, err => this.spinnerService.setSoftSpinnerShowFlag(false));
    } else {
      // lista
      this.dolarizacionService.getDolarizacion(copy).subscribe(x => {
        this.setupDolarizacion(x);
      }, err => this.spinnerService.setSoftSpinnerShowFlag(false));
    }
    this.firstLoad = false;
  }

  setupDolarizacion(data) {
    data.forEach(y => {
      y['Aceptar'] = false;
      y['Rechazar'] = false;
      y['Motivo'] = '';
      y['InputVisible'] = false;
      y['ValorCotizacionEditado'] = null;
      y['FechaLimitePesificacionEditado'] = null;
    });
    this.dolarizacion = [...this.dolarizacion, ...data];
    this.filter.Page = this.filter.Page + 1;
    if (this.filter.Page > 0 && !data.length) {
      this.finalReached = true;
    }
    this.spinnerService.setSoftSpinnerShowFlag(false);
  }

  toggleFilters(action: boolean = null) {
    this.showFilters = action !== null ? action : !this.showFilters;
    setTimeout(_ => {
      this.recalcularPosicionHeader();
    });
  }

  checkChange(row, isAcep, e) {
    if (isAcep) {
      row.Aceptar = e.checked;
      row.Rechazar = e.checked ? false : row.Rechazar;
      row.Motivo = '';
    } else {
      row.Rechazar = e.checked;
      row.Aceptar = e.checked ? false : row.Aceptar;
    }
  }

  displayInput(row) {
    if (this.viewHistory) {return;}
    row.Motivo = row.Motivo !== '' ? row.Motivo : '';
    row.InputVisible = true;
    setTimeout(() => {
      this.motivoInput.nativeElement.focus();
    }, 100);
  }

  saveMotivo(row) {
    if (!row.Motivo.trim().length) {
      row.Motivo = '';
    } else {
      row.Motivo = row.Motivo.trim();
    }
    row.InputVisible = false;
  }

  openFilter(titulo) {
    clearTimeout(this.sortTimeout);
    const index = this.filtersNames.findIndex(x => x.column === titulo);
    if (index > -1 && titulo !== 'Acción') {
      // construimos las settings
      const settings: FilterSettings = {
        FilterType: this.filtersNames[index].filterType,
        FilterTitle: titulo,
        FilterName: this.filtersNames[index].filter
      };
      if (this.filtersNames[index].filterType === FilterType.dateRange) {
        settings.MinDate = 1;
        settings.MaxDate = moment().add(2, 'years').unix();
      }
      if (this.filter.hasOwnProperty(this.filtersNames[index].filter)) {
        // el filtro existe por lo que lo generamos como previous value para llenar el dialog
        // cacheamos el valor para no repetir codigo
        const value = this.filter[this.filtersNames[index].filter];
        switch (this.filtersNames[index].filterType) {
          case FilterType.string:
          case FilterType.tipoPosicion:
            settings.PreviousString = value;
            settings.FilterPlaceholder = titulo;
            break;
          case FilterType.dateRange:
            settings.PreviousNumberMin = value.Desde;
            settings.PreviousNumberMax = value.Hasta;
            break;
          case FilterType.numberRange:
            settings.PreviousNumberMin = value.MinValue;
            settings.PreviousNumberMax = value.MaxValue;
            break;
          case FilterType.colaborador:
          case FilterType.acopio:
          case FilterType.cliente:
            settings.PreviousChipList = value;
            break;
          case FilterType.producto:
          case FilterType.tipoNegocio:
            settings.PreviousArrayNum = value;
            settings.FilterPlaceholder = titulo;
            break;
          case FilterType.number:
          case FilterType.cosecha:
            settings.PreviousNumberMin = value;
            break;
        }
      }
      this.dialogsService.showGenericFilterDialog(settings).subscribe(res => {
        if (res) {
          switch (res.FilterType) {
            case FilterType.colaborador:
            case FilterType.acopio:
            case FilterType.cliente:
            case FilterType.cosecha:
            case FilterType.producto:
            case FilterType.tipoNegocio:
            case FilterType.string:
            case FilterType.number:
            case FilterType.tipoPosicion:
              if (res.MinValue !== null) {
                this.filter[res.FilterName] = res.MinValue;

                // solo puede haber un filtro de cliente a la vez, eliminamos el otro
                if (res.FilterName === 'FilterIdCliente') {
                  delete this.filter['FilterNombreCliente'];
                } else if (res.FilterName === 'FilterNombreCliente') {
                  delete this.filter['FilterIdCliente'];
                }

              } else {
                delete this.filter[res.FilterName];
              }
              break;
            case FilterType.numberRange:
              if (res.MinValue !== null && res.MaxValue !== null) {
                this.filter[res.FilterName] = {MinValue: res.MinValue, MaxValue: res.MaxValue};
              } else {
                delete this.filter[res.FilterName];
              }
              break;
            case FilterType.dateRange:
              if (res.MinValue !== null && res.MaxValue !== null) {
                this.filter[res.FilterName] = {Desde: res.MinValue, Hasta: res.MaxValue};
              } else {
                delete this.filter[res.FilterName];
              }
              break;
          }

          // luego de editar el filtro, lo guardamos para no mezclar los filtros
          this.backupFilters();
          this.loadData();
          this.buildChips();
        }
      });

    }
  }

  buildChips() {
    const chipList = [];
    Object.keys(this.filter).forEach(key => {
      if (key !== 'AscendingOrder' && key !== 'ColumnOrder' && key !== 'Page') {
        let itemLabel = '';
        const filterNameIndex = this.filtersNames.findIndex(x => x.filter === key);
        const prefix = this.filtersNames[filterNameIndex].column + ' / ';
        switch (this.filtersNames[filterNameIndex].filterType) {
          case FilterType.number:
          case FilterType.string:
            itemLabel = prefix + this.filter[key];
            break;
          case FilterType.numberRange:
            itemLabel = prefix + this.filter[key].MinValue + ' - ' + this.filter[key].MaxValue;
            break;
          case FilterType.dateRange:
            itemLabel = prefix + moment.unix(this.filter[key].Desde).format('DD/MM/YYYY').toString() + ' - ' + moment.unix(this.filter[key].Hasta).format('DD/MM/YYYY').toString();
            break;
          case FilterType.tipoNegocio:
            const tipos = this.negociosService.getTipoSelectOptions();
            itemLabel = prefix + (this.filter[key].length > 1 ? 'Varios' : tipos[tipos.findIndex(x => x.ID === this.filter[key][0])].Tipo_Negocio);
            break;
          case FilterType.producto:
            itemLabel = prefix + (this.filter[key].length > 1 ? 'Varios' : this.productoOptions[this.productoOptions.findIndex(x => x.ID === this.filter[key][0])].Producto);
            break;
          case FilterType.cosecha:
            itemLabel = prefix + (this.cosechaOptions[this.cosechaOptions.findIndex(x => x.ID === this.filter[key])].Cosecha);
            break;
          case FilterType.cliente:
          case FilterType.colaborador:
          case FilterType.acopio:
            itemLabel = prefix + (this.filter[key].length > 1 ? 'Varios' : this.filter[key][0].ItemLabel);
            break;
          case FilterType.tipoPosicion:
            const val = this.filter[key];
            itemLabel = prefix + (val === 'D' ? 'Disponible' : val === 'F' ? 'Forward' : 'Pago Diferido');
            break;
        }
        const item = {
          label: itemLabel,
          filter: key
        };
        chipList.push(item);
      }
    });
    this.filterChips = chipList;
    setTimeout(_ => {
      this.recalcularPosicionHeader();
    });
  }

  hasFilter(titulo) {
    const index = this.filtersNames.findIndex(x => x.column === titulo);
    return index === -1 ? false : this.filter.hasOwnProperty(this.filtersNames[index].filter);
  }

  changeOrInvertFiltering(titulo, immediate: boolean) {
    clearTimeout(this.sortTimeout);
    this.sortTimeout = setTimeout(() => {
      if (this.filter.ColumnOrder !== titulo) {
        this.filter.ColumnOrder = titulo;
        this.filter.AscendingOrder = false;
      } else {
        this.filter.AscendingOrder = !this.filter.AscendingOrder;
      }
      this.loadData();
    }, immediate ? 0 : 250);

  }

  getCellValue(item, row = null) {
    if (item.key === 'FechaLiquidacion' ||
      item.key === 'FechaContrato' ||
      item.key === 'FechaCotizacion') {
      return moment.unix(item.value).utc().format('DD/MM/YYYY').toString();
    } else if (item.key === 'ToneladasLiquidacion' ||
      item.key === 'ToneladasContrato') {
      return this.tnsPipe.transform(item.value);
    } else if (item.key === 'SaldoNeto') {
      return this.pricePipe.transform(item.value, 'fill');
    } else if (item.key === 'ValorCotizacion') {
      return row['ValorCotizacionEditado'] !== null ? this.pricePipe.transform(row['ValorCotizacionEditado'], 'fill,4') : this.pricePipe.transform(row['ValorCotizacion'], 'fill,4');
    } else if (item.key === 'FechaLimitePesificacion') {
      return row['FechaLimitePesificacionEditado'] !== null ? moment.unix(row['FechaLimitePesificacionEditado']).utc().format('DD/MM/YYYY').toString() : moment.unix(item.value).utc().format('DD/MM/YYYY').toString();
    } else {
      return item.value;
    }
  }

  removeFilter(chip) {
    delete this.filter[chip.filter];
    this.buildChips();
  }

  editField(item, row) {
    if (item.key === 'ValorCotizacion') {
      this.dialogsService.showEditNumberDialog('Editar TC Propuesto', row['ValorCotizacionEditado'] !== null ? row['ValorCotizacionEditado'] : item.value).subscribe(x => {
        if (x) {
          // si el valor editado es igual al original, lo eliminamos como edicion, de lo contrario lo asignamos
          row['ValorCotizacionEditado'] = x === row['ValorCotizacion'] ? null : x;
        }
      });
    } else if (item.key === 'FechaLimitePesificacion') {
      const settings: FilterSettings = {
        FilterTitle: 'Fec.Tope Pesif.',
        FilterName: 'FechaLimitePesificacionEditado',
        FilterType: FilterType.date,
        PreviousNumberMin: row['FechaLimitePesificacionEditado'] !== null ?
                           row['FechaLimitePesificacionEditado'] :
                           moment.unix(item.value).add(3, 'hours').unix(),
        MinDate: moment().startOf('day').unix(),
        MaxDate: moment().add(10, 'y').unix()
      };

      this.dialogsService.showGenericFilterDialog(settings).subscribe(x => {
        if (x) {
          if (x.MinValue === null) {
            row['FechaLimitePesificacionEditado'] = null;
          } else {
            const equals = moment.unix(row['FechaLimitePesificacion']).utc().format('DD/MM/YY') === moment.unix(x.MinValue).utc().format('DD/MM/YY');
            row['FechaLimitePesificacionEditado'] = equals ? null : x.MinValue;
          }
        }
      });
    }
  }

  getTooltip(item, row) {
    if (item.key === 'ValorCotizacion' && row['ValorCotizacionEditado'] !== null) {
      return `Editado. Valor Original: ${this.pricePipe.transform(item.value, 'fill')}`;
    } else if (item.key === 'FechaLimitePesificacion' && row['FechaLimitePesificacionEditado'] !== null) {
      return `Editado. Valor Original: ${moment.unix(item.value).utc().format('DD/MM/YYYY').toString()}`;
    }
    return '';
  }

  applyFilters() {
    this.toggleFilters(false);
    this.loadData();
  }

  resetFilters() {
    this.filter = {
      AscendingOrder: true,
      ColumnOrder: '',
      Page: 0
    };
    this.buildChips();
    this.toggleFilters(false);
    this.loadData();
  }

  public onSubmit() {
    if (this.dolarizacionLoading) {
      return;
    }
    if (!this.dolarizacion.filter(x => x.Aceptar || x.Rechazar).length) {
      this.openSnackbar('Por favor, seleccione al menos un comprobante para Aceptar o Rechazar', 'info');
      return;
    }
    if (this.dolarizacion.filter(x => x.Rechazar && !x.Motivo.length).length > 0) {
      this.openSnackbar('Todos los comprobantes a rechazar, deben poseer un motivo', 'warning');
      return;
    }
    // generamos el objeto a partir de las dolarizaciones actuales
    const payload = this.dolarizacion.filter(x => x.Aceptar || x.Rechazar).map(x => ({
      Id: x.Id,
      Aprobada: x.Aceptar,
      ValorCotizacion: x.ValorCotizacionEditado !== null ? x.ValorCotizacionEditado : x.ValorCotizacion,
      FechaLimitePesificacion: x.FechaLimitePesificacionEditado !== null ? x.FechaLimitePesificacionEditado : x.FechaLimitePesificacion,
      MotivoRechazo: x.Motivo
    }));
    this.spinnerService.setSoftSpinnerShowFlag(true);
    this.dolarizacionService.sendDolarizacion(payload).subscribe(x => {
      this.spinnerService.setSoftSpinnerShowFlag(false);
      if (x) {
        this.loadData();
      } else {
        this.openSnackbar('Ha ocurrido un error al enviar las solicitudes.', 'warning');
      }
    }, err => this.spinnerService.setSoftSpinnerShowFlag(false));
  }

  openSnackbar(data, type) {
    this.snackBar.openFromComponent(NotificationSnackbarComponent, {
      duration: 4000,
      data: data,
      extraClasses: [`agd-${type}-snackbar`]
    });
  }

  onScroll(e, item) {
    // Con esta técnica simulamos un scroll horizontal que está arriba del div en cuestión (recordemos que html por defecto deja
    // el scroll horizontal por DEBAJO de dicho div. Nosotros ocultamos ese scroll y agregamos uno arriba que usa este listener)
    // No olvidar que el elemento a scrollear artificialmente debe tener overflow: hidden u overflow: auto y ser un div cuyo contenido
    // tenga ancho definido

    if (item === 'main') {
      this.table.nativeElement.scrollLeft = e.target.scrollLeft;
      this.tableHeader.nativeElement.scrollLeft = e.target.scrollLeft;
    } else if (item === 'header') {
      this.topScroller.nativeElement.scrollLeft = e.target.scrollLeft;
      this.table.nativeElement.scrollLeft = e.target.scrollLeft;
    } else if (item === 'table') {
      this.topScroller.nativeElement.scrollLeft = e.target.scrollLeft;
      this.tableHeader.nativeElement.scrollLeft = e.target.scrollLeft;
    }

  }

  toggleView(type, e = null) {
    // en caso de tocar el mismo boton, no recargamos la vista
    if ((type === 'hist' && this.viewHistory) || (type !== 'hist' && !this.viewHistory)) {return; }

    // hacemos esto para que no se guarde la primera vez que entramos el filtro
    if (!this.firstLoad) {
      this.backupFilters();
    }

    this.viewHistory = type === 'hist' ? true : false;
    this.columnas = this.viewHistory ? this.columnasHistorial : this.columnasLista;
    this.anchoDeCelda = this.viewHistory ? this.anchoDeCeldaHistorial : this.anchoDeCeldaLista;
    this.recalcularAnchoTabla();
    // cambiamos los filtros
    if (this.viewHistory) {
      // en caso de haber un filtro en backup, lo usamos, de lo contrario lo construimos
      if (this.historyFilterBackup) {
        this.filter = this.copyObject(this.historyFilterBackup);
      } else {
        // por defecto la columna de ordenamiento es la fecha para el historial
        this.filter = {
          AscendingOrder: false,
          ColumnOrder: 'Fecha',
        };
      }
    } else {
      // en caso de haber un filtro en backup, lo usamos, de lo contrario lo construimos
      if (this.listFilterBackup) {
        this.filter = this.copyObject(this.listFilterBackup);
      }
    }
    this.buildChips();
    if (e) {
      e.stopPropagation();
    }
    this.loadData();
  }

  getUnixToStringDate(value) {
    return moment.unix(value).utc().format('DD/MM/YYYY').toString();
  }

  copyObject(original) {
    const copy = {};
    Object.keys(original).forEach(key => {
      copy[key] = original[key];
    });
    return copy;
  }

  backupFilters() {
    if (this.viewHistory) {
      this.historyFilterBackup = this.copyObject(this.filter);
    } else {
      this.listFilterBackup = this.copyObject(this.filter);
    }
  }

  recalcularAnchoTabla() {
    this.anchoTabla = this.anchoDeCelda.map(x => parseInt(x.slice(0, -2), 10)).reduce((p, c) => p + c) + 'px';
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/dolarizacion/dolarizacion.component.ts